import React from "react";
import { Document, Image, Page, Text, View } from "@react-pdf/renderer";
import logo from "../sharedCode/bailey-helicopters-logo-monochrome.png";
import { styles } from "../sharedCode/ReportBuilder";

// generate this on app load to ensure the Roboto font and the icon jpg are cached on the iPad (otherwise they are lazy loaded)
// TODO is there a way to just turn off lazy loading for them instead?
export const PdfFontLoader = (): JSX.Element => {
    return (
        <Document>
            <Page size="LETTER" style={styles.pageStyle}>
                <View style={{ width: 140 }}>
                    <Image style={{ width: 72 }} src={logo} />
                </View>
                <View style={{ flex: 1, width: 262 }}>
                    <Text style={styles.corporateAddress}>regular</Text>
                    <Text style={styles.ticketNumber}>bold</Text>
                </View>
            </Page>
        </Document>
    );
};
